import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string = "#16B685") => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18 19C18 16.7909 15.3137 15 12 15C8.68629 15 6 16.7909 6 19M12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12Z"
            stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

)

export const UserPick: React.FC<IconProps> = ({color, size}) => (
    <IconWrapper viewBox={'0 0 26 26'} {...{size, color, renderIcon}} />
)
